<!DOCTYPE html>
<html lang="en">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Document</title>
        <link rel="stylesheet" href="nari.component.css" />
        <style>
            body {
                font-size: 16px;
            }

            .container {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px;
            }

            .left {
                display: flex;
                align-items: center;
            }

            .left img {
                width: 30px;
                height: 30px;
            }

            .right {
                text-align: right;
            }
            h1 {
                font-size: 24px;
                text-align: center;
                color: whitesmoke;
            }

            .venue {
                text-align: center;
                font-weight: bold;
                margin: 20px auto;
                color: whitesmoke;
            }

            @media screen and (max-width: 600px) {
                body {
                    font-size: 14px;
                }

                .container {
                    flex-direction: column;
                    align-items: center;
                }

                .left img {
                    width: 40px;
                    height: 40px;
                }

                .right {
                    text-align: center;
                }
            }
        </style>
    </head>
    <body>
        <div class="container">
            <div class="left">
                <img src="/assets/images/nsslogo.jpg" alt="" width="50px" height="50px" />
                <h1 style="color: darkorange; font-weight: bold">నారీ శక్తి సమ్మేళనం గోదావరి విభాగ్</h1>
            </div>
            <div class="right">
                <a
                    class="btn btn-primary"
                    href="https://forms.gle/pYYTB4VBFd5SaEyPA"
                    role="button"
                    style="background-color: darkorange; border: none; color: white; font-family: goudy old style"
                    ><b>Register Now</b></a
                >
            </div>
        </div>
        <div style="margin: 20px; text-align: justify; color: white">
            <p>
                వేల సంవత్సరాల నాటి నుండి భారతదేశ, భారతీయ స్త్రీ ఖ్యాతి దేదీప్యమానంగా వెలుగొందింది. వేద, ప్రాచీన, మధ్య కాలం నుండి కూడా భారతీయ
                స్త్రీ అన్ని రంగాలలో సమర్ధురాలై, కుటుంబ, సమాజ నిర్మాణంలో విశేష సహకారం అందించింది. తన అపారమైన శక్తి యుక్తులతో కుటిల దేశ
                వ్యతిరేక రాజుల బారినుండి రాజ్యాలను, ప్రజలను కాపాడింది. సాహిత్యంలో, నాట్యంలో, పాండిత్యంలో, సమాజ సేవలో, నాయకత్వంలో, ఆర్ధిక
                రంగంలో భారత స్త్రీ ప్రపంచంలోని ఇతర స్త్రీలకంటే అత్యున్నత స్థాయిలో ప్రతిభ కనబరిచి యావత్ ప్రపంచానికే దిక్సూచిగా నిలిచింది.
                స్వాతంత్ర్యానికి పూర్వం కూడా ఎంతోమంది గొప్ప రాణులు, సాహితీకారులు, స్వాతంత్ర ధీరమణులు ఈ దేశానికి తమ సేవలను అందించారు.
                స్వాతంత్య్రానంతరం కూడా గొప్ప అభ్యున్నత భావలనలతో కాలక్రమంలో సమాజాన్ని పట్టి వీడిస్తున్న అనేక మహిళా వ్యతిరేక, సమాజ వ్యతిరేక
                రుగ్మతలను రూపుమాపటంలో కృషి చేసారు. వారి జీవితాలను, ధైర్య సాహసాలను, ఆలోచనలను నేటి తరం స్ఫూర్తిగా తీసుకోవాల్సిన బాధ్యత ఎంతైనా
                ఉంది. ఆ క్రమంలోనే మహిళల సమస్యలకు పరిష్కార మార్గాలను అన్వేషించడానికి, నేటి భారతదేశంలో స్త్రీలు ఎదుర్కుంటున్న విపక్షనుండి
                బయటపడేలా వారిని చైతన్యవంతులుగా చేయడం కోసం, వివిధ రంగాల మహిళల భాగస్వామ్యంతో భారత దేశ సమగ్రాభివృద్ధికి సహకారం అందించేలా మహిళా
                శక్తిని జాగృత పరచడం కోసం, హిందూ, భారతీయ సంస్కృతి, సంప్రదాయాలపట్ల జరుగుతున్న కుట్రలను అడ్డుకుని, ప్రభుత్వాల దృష్టికి
                తీసుకువెళ్తూ, భారతీయ స్త్రీలలో కనుమరుగవుతున్న భారతీయ, హిందూ చింతనను పెంపొందించడం కోసం దశాబ్ద కాలంగా పనిచేస్తున్నది మహిళా
                సమన్వయము. వ్యక్తి, కుటుంబ, సమాజ నిర్మాణంలో మహిళలను సక్రియం చేస్తూ, మహిళలు అభివృద్ధి ద్వారా దేశాభివృద్ధి అని మహిళలను చైతన్య
                పరుస్తూ వడివడిగా అడుగులు వేస్తోంది. మహిళలలో నాయకత్వ పటిమ, నిర్ణయ సామర్థ్యం పెంపొందించి వారిని సర్వశక్తిమంతులు, స్వతంత్రులుగా
                తీర్చిదిద్దడం సమ్మేళనం యొక్క ఉద్దేశ్యం.
            </p>
        </div>
        <div class="image-container" style="display: flex; margin: 10px">
            <img src="/assets/images/NariSakthiSammelanam1.jpg" width="350px" height="300px" style="margin: 10px" />
            <img src="/assets/images/NariSakthiSammelanam2.jpg" width="350px" height="300px" style="margin: 10px" />
            <img src="/assets/images/NariSakthiSammelanam3.jpg" width="350px" height="300px" style="margin: 10px" />
            <img src="/assets/images/NariSakthiSammelanam4.jpg" width="350px" height="300px" style="margin: 10px" />
        </div>
        <h1><u>VENUE</u></h1>
        <div class="venue">
            <p>GSL Medical Collage, Rajamahendravaram</p>
            <p>Date: 29-10-2023 - Sunday</p>
            <p>Morning 9:30 A.M to Evening 4:00 P.M</p>
        </div>
        <div class="button-container a">
            <a
                href="https://forms.gle/pYYTB4VBFd5SaEyPA"
                style="
                    text-decoration: none;
                    text-align: center;
                    border: solid white;
                    width: fit-content;
                    padding: 5px;
                    background-color: white;

                    font-weight: bold;
                    color: darkorange;
                "
                >Register Now</a
            >
        </div>
    </body>
</html>
